function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.1154 11.8695C19.0464 11.9388 18.9662 11.9793 18.883 11.9937C18.6333 12.0371 18.3666 11.8527 18.3666 11.559V9.71173H2.92148C2.59383 9.71637 2.28906 9.54422 2.12388 9.26121C1.95871 8.97821 1.95871 8.62818 2.12388 8.34518C2.28906 8.06217 2.59383 7.89002 2.92148 7.89466H18.3666V6.04742C18.3666 5.65675 18.8392 5.45978 19.1154 5.73688L21.8712 8.49266C22.0429 8.66437 22.0429 8.94202 21.8712 9.11373L19.1154 11.8695ZM4.88456 12.1305C4.95361 12.0613 5.0338 12.0208 5.11702 12.0063C5.36667 11.963 5.6334 12.1474 5.6334 12.4411V14.2883H21.0785C21.4062 14.2837 21.7109 14.4558 21.8761 14.7388C22.0413 15.0218 22.0413 15.3718 21.8761 15.6549C21.7109 15.9379 21.4062 16.11 21.0785 16.1054H5.6334V17.9526C5.6334 18.3433 5.16076 18.5403 4.88456 18.2632L2.12879 15.5074C1.95707 15.3357 1.95707 15.058 2.12879 14.8863L4.88456 12.1305Z",
  fill: "#ABB1BB"
});

const SvgSwitch = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSwitch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/switch.3229703f.svg";
export { ForwardRef as ReactComponent };